export default function AboutPage() {
  return (
    <div className="container-x py-16 lg:py-24" data-testid="about-page">
      <div className="max-w-3xl">
        <div className="font-script text-2xl text-[#D97757]">our story</div>
        <h1 className="font-serif text-5xl lg:text-6xl mt-2 leading-tight">
          The first teddy was for our son Teddy, in the garden.
        </h1>
        <p className="mt-6 text-lg text-[#5C4D43] leading-relaxed">
          Teddys Tiny Friends began on a warm afternoon in our back garden. We&apos;d been
          working on a little crocheted bear for months — quiet evenings of stitches, a few
          unpicked rows, a lot of tea — and finally it was finished. We tucked the bear into our
          son <em>Teddy&apos;s</em> arms under the apple tree, and the look on his face is the
          reason this little shop exists.
        </p>
        <p className="mt-4 text-lg text-[#5C4D43] leading-relaxed">
          That first bear is still his favourite. Soon there was a bunny for his cousin, a duck
          for a friend&apos;s newborn, then a tiny capybara just because. The basket of yarn grew,
          our living-room corner became a studio, and Teddys Tiny Friends was born — named after
          the little boy who started it all.
        </p>
      </div>

      <div className="mt-16 grid lg:grid-cols-2 gap-12 items-center">
        <img
          src={`${process.env.REACT_APP_BACKEND_URL}/api/static/products/chenille-yarn-neutral.png`}
          alt="Soft chenille yarn in neutral cream and sage tones"
          className="rounded-3xl w-full aspect-[4/5] object-cover"
        />
        <div>
          <h2 className="font-serif text-4xl">Made by hand, made to last.</h2>
          <p className="mt-4 text-[#5C4D43] leading-relaxed">
            Every friend is crocheted from 100% cotton yarn, stuffed with hypoallergenic
            polyfill, and finished with safety-embroidered features — no glass eyes, no small
            parts. Each piece takes between 1 and 3 days to complete, depending on size and detail.
          </p>
          <p className="mt-4 text-[#5C4D43] leading-relaxed">
            We&apos;re a brand-new small business, just the two of us at the kitchen table. There&apos;s
            no factory, no warehouse, no shelves of stock — every animal is made just for you
            after you order, which means each one is a tiny one-of-a-kind.
          </p>
          <div className="mt-8 p-6 rounded-3xl bg-[#F4EFE6] border border-[#EAE3D9]" data-testid="delivery-note">
            <div className="font-script text-xl text-[#D97757]">delivery</div>
            <div className="mt-1 font-serif text-2xl">UK only · Royal Mail 2nd class</div>
            <p className="mt-3 text-sm text-[#5C4D43] leading-relaxed">
              We currently post within the UK using Royal Mail 2nd class. Because each friend
              is hand-crocheted to order, the time from order to your door depends on how busy
              the studio is — during quieter weeks orders ship within a few days, during higher
              demand it can take longer. We&apos;ll always keep you updated.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
